import React from "react";
import { TitleH1, TitleH2 } from "../../../../shared/native/typography.styles";
import LinkCard from "../../../../shared/cards/linkCard/LinkCard";
import { useAppDispatch, useAppSelector } from "../../../../../core/hooks/redux";
import { fetchGetExams } from "../../../../../store/modules/notifications/notificationsThunk";
import openUrlInNewTab from "../../utils/openUrlInNewTab";
import { EXAM_BASE_URL, EXAM_LEVEL_ORDER, EXAM_LEVEL_TITLES } from "../../constants/examLevels";
import ExamDiscipline from "../../interfaces/ExamDiscipline";
import colors from "../../../../../core/styles/colors";
import { ReactComponent as CheckMarkIcon } from "../../../../../core/static/icons/check-mark.svg";
import {
  EntranceExamsList as StyledEntranceExamsList,
  EntranceExamsListContainer,
  EntranceExamsListContent,
  ExamCard,
  ExamCardContent,
  ExamCardStatus,
  ExamLevelSection,
} from "./entranceExamsList.styles";

const EntranceExamsList: React.FC = () => {
  const dispatch = useAppDispatch();
  const { exams } = useAppSelector((state) => state.modulesState.notificationsState);

  React.useEffect(() => {
    dispatch(fetchGetExams());
  }, [dispatch]);

  const examClickHandler = (exam: ExamDiscipline): void => {
    if (!exam.token) {
      return;
    }

    openUrlInNewTab(`${EXAM_BASE_URL}${exam.token}`);
  };

  return (
    <EntranceExamsListContainer>
      <EntranceExamsListContent>
        <TitleH1>Вступительные испытания</TitleH1>

        <StyledEntranceExamsList>
          {EXAM_LEVEL_ORDER.map((level) => {
            const levelExams = exams?.[level];

            if (!levelExams?.length) {
              return null;
            }

            return (
              <ExamLevelSection key={level}>
                <TitleH2 style={{ color: colors.black.general }}>
                  {EXAM_LEVEL_TITLES[level]}
                </TitleH2>
                {levelExams.map((exam) => {
                  const isPassed = !exam.token;

                  return (
                    <ExamCard key={`${level}-${exam.name}`} $isPassed={isPassed}>
                      <LinkCard onClick={(): void => examClickHandler(exam)}>
                        <ExamCardContent>
                          <b>{exam.name}</b>
                          <ExamCardStatus $isPassed={isPassed}>
                            {isPassed && <CheckMarkIcon />}
                            {isPassed ? "Сдано" : "Перейти"}
                          </ExamCardStatus>
                        </ExamCardContent>
                      </LinkCard>
                    </ExamCard>
                  );
                })}
              </ExamLevelSection>
            );
          })}
        </StyledEntranceExamsList>
      </EntranceExamsListContent>
    </EntranceExamsListContainer>
  );
};

export default EntranceExamsList;
